import { render, staticRenderFns } from "./BuyForm.vue?vue&type=template&id=03ba2aa9&scoped=true&"
import script from "./BuyForm.vue?vue&type=script&lang=js&"
export * from "./BuyForm.vue?vue&type=script&lang=js&"
import style0 from "./BuyForm.vue?vue&type=style&index=0&id=03ba2aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ba2aa9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VTextField})
